var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 9.43997C16.73 8.46997 15.94 7.71997 14.85 7.37997V6.58997C14.85 6.17997 14.51 5.83997 14.1 5.83997C13.69 5.83997 13.35 6.17997 13.35 6.58997V7.17996H10.64V6.58997C10.64 6.17997 10.3 5.83997 9.89 5.83997C9.48 5.83997 9.14 6.17997 9.14 6.58997V7.37997C8.05 7.71997 7.25999 8.46997 6.83999 9.43997C6.69999 9.76997 6.93998 10.15 7.29998 10.15H16.67C17.05 10.14 17.29 9.76997 17.15 9.43997Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.14C17.28 11.14 17.5 11.36 17.5 11.64V14.17C17.5 16.37 16 18.17 13.5 18.17H10.5C8 18.17 6.5 16.37 6.5 14.17V11.64C6.5 11.36 6.72 11.14 7 11.14H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarcircle);
export default __webpack_public_path__ + "static/media/calendarcircle.356f1231651fc5917d3aa3b6b4385b79.svg";
export { ForwardRef as ReactComponent };